<script lang="ts">
	import { CircleWithAdd, XIcon } from "@hitit/new_ui/src";
	import { createEventDispatcher } from "svelte";
	import DragAndDrop from "../../../components/DragAndDrop.svelte";
	export let editmode = false;
	export let images: string[] = [];

	let addHover = false;

	function fileExtraction(file: File) {
		const extMatch = file.name.match(
			/(\.png|\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG)$/
		);

		if (!extMatch) return;
		const ext = extMatch[1].replace(".", "");
		return {
			file: file,
			name: file.name,
			type: ext.toUpperCase(),
		};
	}

	const dispatch = createEventDispatcher();
	const maximumLength = 10;
	const newImageHandler = (e: { detail: File }) =>
		dispatch("NEW_IMAGE", fileExtraction(e.detail));
	const updateImageHandler = (e: { detail: File }, index: number) =>
		dispatch("UPDATE_IMAGE", { index, ...fileExtraction(e.detail) });
	const deleteImageHandler = (index: number) =>
		dispatch("DELETE_IMAGE", { index });

</script>

<div class="container">
	{#if editmode}
		{#each images as src, index}
			<div class="outer">
				<DragAndDrop on:file-update={(e) => updateImageHandler(e, index)}>
					<div class="inner">
						<img src={src} alt="" />
						<div
							class="delete"
							on:click|stopPropagation={() => deleteImageHandler(index)}>
							<span class="x-icon">
								<XIcon fill={'white'} />
							</span>
						</div>
					</div>
				</DragAndDrop>
			</div>
		{/each}
		{#if images.length < maximumLength}
			<div
				id="newImage"
				class="outer"
				on:mouseenter={() => (addHover = true)}
				on:mouseleave={() => (addHover = false)}>
				<DragAndDrop let:enter on:file-update={newImageHandler}>
					<div class="inner">
						<span class="add">
							<CircleWithAdd fill={enter || addHover ? '#6591fa' : '#6d6f76'} />
						</span>
					</div>
				</DragAndDrop>
			</div>
		{/if}
	{:else}
		{#each images as src}
			<div class="outer"><img src={src} alt="" /></div>
		{/each}
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-wrap: wrap;
		gap: 1px;
		width: 100%;

		.outer {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			width: calc((100% / 3) - 1px);
			max-width: calc((100% / 3) - 1px);

			img {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
			&:after {
				content: "";
				display: block;
				padding-bottom: 100%;
			}

			.inner {
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				width: 100%;
				height: 100%;
				background-color: #f0f0f4;

				.delete {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					top: 0;
					right: 0;
					background-color: #f66d6c;
					width: 30px;
					height: 30px;
					border-radius: 0px 0px 0px 10px;

					.x-icon {
						width: 15px;
						height: 15px;
					}
				}

				&:hover {
					cursor: pointer;
				}

				.add {
					width: 35px;
					height: 35px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			.outer {
				width: calc((100% / 4) - 1px);
				max-width: calc((100% / 4) - 1px);
			}
		}
	}

</style>
